import { isNull } from "../../../../util/TypeUtil";

export default class StoryPlayerState {
    constructor() {
        this.reset();
    }

    reset() {
        this._storyStart = Number.POSITIVE_INFINITY;
        this._storyNodeResults = {};
        this._unlockedStoryArcs = [];
        this._unlockedStoryNodes = [];
        this._availableStoryArcs = [];
        this._availableStoryNodes = [];
        this._completedStoryArcs = [];
        this._completedStoryNodes = [];
        this._unlockedStoryArcsTimes = {};
        this._unlockedStoryNodesTimes = {};
        this._availableStoryArcsTimes = {};
        this._availableStoryNodesTimes = {};
        this._completedStoryArcsTimes = {};
        this._completedStoryNodesTimes = {};
    }

    unlockStoryArc(storyArc, time) {
        this._unlockedStoryArcs.add(storyArc);
        this._unlockedStoryArcsTimes[storyArc.id] = time;
    }

    unlockStoryNode(storyNode, time) {
        this._unlockedStoryNodes.add(storyNode);
        this._unlockedStoryNodesTimes[storyNode.id] = time;
    }

    storyArcAvailable(storyArc, time) {
        this._availableStoryArcs.add(storyArc);
        this._availableStoryArcsTimes[storyArc.id] = time;
    }

    storyArcUnAvailable(storyArc, time) {
        this._availableStoryArcs.remove(storyArc);
        delete this._availableStoryArcsTimes[storyArc.id];
    }

    storyArcCompleted(storyArc, time) {
        this._completedStoryArcs.add(storyArc);
        this._completedStoryArcsTimes[storyArc.id] = time;
    }

    storyNodeAvailable(storyNode, time) {
        this._availableStoryNodes.add(storyNode);
        this._availableStoryNodesTimes[storyNode.id] = time;
    }

    storyNodeUnAvailable(storyNode, time) {
        this._availableStoryNodes.remove(storyNode);
        delete this._availableStoryNodesTimes[storyNode.id];
    }

    storyNodeCompleted(storyNode, time, result) {
        this._completedStoryNodes.add(storyNode);
        this._completedStoryNodesTimes[storyNode.id] = time;
        if (result !== null && result !== undefined) {
            this._storyNodeResults[storyNode.id] = result;
        }
    }

    isStoryArcUnlocked(storyArc) {
        //FIXME: looking up whether there is a time stored is probably faster
        return this._unlockedStoryArcs.contains(storyArc);
    }

    isStoryArcAvailable(storyArc) {
        //FIXME: looking up whether there is a time stored is probably faster
        return this._availableStoryArcs.contains(storyArc);
    }

    isStoryArcCompleted(storyArc) {
        //FIXME: looking up whether there is a time stored is probably faster
        return this._completedStoryArcs.contains(storyArc);
    }

    isStoryNodeUnlocked(storyNode) {
        //FIXME: looking up whether there is a time stored is probably faster
        return this._unlockedStoryNodes.contains(storyNode);
    }

    isStoryNodeAvailable(storyNode) {
        //FIXME: looking up whether there is a time stored is probably faster
        return this._availableStoryNodes.contains(storyNode);
    }

    isStoryNodeCompleted(storyNode) {
        //FIXME: looking up whether there is a time stored is probably faster
        return this._completedStoryNodes.contains(storyNode);
    }

    storyNodeUnlockedTime({ id }) {
        //FIXME: looking up whether there is a time stored is probably faster
        return this.getTime(this._unlockedStoryNodesTimes[id]);
    }

    storyNodeAvailableTime({ id }) {
        //FIXME: looking up whether there is a time stored is probably faster
        return this.getTime(this._availableStoryNodesTimes[id]);
    }

    storyNodeCompletedTime({ id }) {
        return this.getTime(this._completedStoryNodesTimes[id]);
    }

    storyArcUnlockedTime({ id }) {
        return this.getTime(this._unlockedStoryArcsTimes[id]);
    }

    storyArcAvailableTime({ id }) {
        return this.getTime(this._availableStoryArcsTimes[id]);
    }

    storyArcCompletedTime({ id }) {
        return this.getTime(this._completedStoryArcsTimes[id]);
    }

    getStoryStartTime() {
        return this._storyStart;
    }

    start(time) {
        this._storyStart = time;
    }

    getTime(lookupTime) {
        if (!isNaN(lookupTime)) {
            return lookupTime;
        }
        return Number.POSITIVE_INFINITY;
    }

    unlockedStoryArcs() {
        return this._unlockedStoryArcs.getIterator();
    }

    availableStoryArcs() {
        return this._availableStoryArcs.getIterator();
    }

    completedStoryArcs() {
        return this._completedStoryArcs.getIterator();
    }

    unlockedStoryNodes() {
        return this._unlockedStoryNodes.getIterator();
    }

    availableStoryNodes() {
        return this._availableStoryNodes.getIterator();
    }

    completedStoryNodes() {
        return this._completedStoryNodes.getIterator();
    }

    getResult({ id }) {
        return this._storyNodeResults[id];
    }

    isStarted() {
        return this._storyStart < Number.POSITIVE_INFINITY;
    }

    toObj() {
        const result = {};
        let itr;
        let storyArc;
        let storyArcId;
        let storyNode;
        let storyNodeId;

        //Set story start time
        result.storyStart = this._storyStart;
        //Unlocked StoryArcs
        result.unlockedStoryArcs = [];
        itr = this._unlockedStoryArcs.getIterator();
        while (itr.hasNext()) {
            storyArc = itr.next();
            result.unlockedStoryArcs.push(storyArc.id);
        }
        result.unlockedStoryArcsTimes = {};
        for (storyArcId in this._unlockedStoryArcsTimes) {
            result.unlockedStoryArcsTimes[storyArcId] = this._unlockedStoryArcsTimes[storyArcId];
        }


        //Available StoryArcs
        result.availableStoryArcs = [];
        result.availableStoryArcsTimes = {};
        itr = this._availableStoryArcs.getIterator();
        while (itr.hasNext()) {
            storyArc = itr.next();
            result.availableStoryArcs.push(storyArc.id);
            result.availableStoryArcsTimes[storyArc.id] = this._availableStoryArcsTimes[storyArc.id];
        }

        //Completed StoryArcs
        result.completedStoryArcs = [];
        result.completedStoryArcsTimes = {};
        itr = this._completedStoryArcs.getIterator();
        while (itr.hasNext()) {
            storyArc = itr.next();
            result.completedStoryArcs.push(storyArc.id);
            result.completedStoryArcsTimes[storyArc.id] = this._completedStoryArcsTimes[storyArc.id];
        }

        //Unlocked StoryNodes
        result.unlockedStoryNodes = [];
        result.unlockedStoryNodesTimes = {};
        itr = this._unlockedStoryNodes.getIterator();
        while (itr.hasNext()) {
            storyNode = itr.next();
            result.unlockedStoryNodes.push(storyNode.id);
            result.unlockedStoryNodesTimes[storyNode.id] = this._unlockedStoryNodesTimes[storyNode.id];
        }

        //Available StoryNodes
        result.availableStoryNodes = [];
        result.availableStoryNodesTimes = {};

        itr = this._availableStoryNodes.getIterator();
        while (itr.hasNext()) {
            storyNode = itr.next();
            result.availableStoryNodes.push(storyNode.id);
            result.availableStoryNodesTimes[storyNode.id] = this._availableStoryNodesTimes[storyNode.id];
        }

        //Completed StoryNodes
        result.completedStoryNodes = [];
        itr = this._completedStoryNodes.getIterator();
        result.completedStoryNodesTimes = {};
        while (itr.hasNext()) {
            storyNode = itr.next();
            result.completedStoryNodes.push(storyNode.id);
            result.completedStoryNodesTimes[storyNode.id] = this._completedStoryNodesTimes[storyNode.id];
        }

        //TODO: how to handle result that was stored at storyNode?

        return result;
    }

    fromObj(input, story) {
        let storyArcId;
        let storyArc;
        let storyNodeId;
        let storyNode;
        let i;

        this.reset();

        if (isNull(input.storyStart)) {
            // Number.POSITIVE_INFINITY is serialized to null. Restore here.
            this._storyStart = Number.POSITIVE_INFINITY;
        }

        /*if (!isNull(input.storyStart) && !isNaN(input.storyStart)) {
            this._storyStart = input.storyStart;
        } else {
            throw new Error("storyStart is not a Number, invalid data");
        }*/

        //UnlockedStoryArcs
        if (Array.isArray(input.unlockedStoryArcs) && input.unlockedStoryArcsTimes) {
            for (i = 0; i < input.unlockedStoryArcs.length; i++) {
                storyArcId = input.unlockedStoryArcs[i];
                storyArc = story.getStoryArcById(storyArcId);
                if (!storyArc) {
                    throw new Error(`Unkown storyarc id '${storyArcId}'`);
                }
                if (isNaN(input.unlockedStoryArcsTimes[storyArcId])) {
                    throw new Error(`Missing unlock time for '${storyArcId}'`);
                }
                this._unlockedStoryArcs.add(storyArc);
                this._unlockedStoryArcsTimes[storyArc.id] = input.unlockedStoryArcsTimes[storyArcId];
            }
        } else {
            throw new Error("unlockedStoryArcs data is invalid");
        }

        //AvailableStoryArcs
        if (Array.isArray(input.availableStoryArcs) && input.availableStoryArcsTimes) {
            for (i = 0; i < input.availableStoryArcs.length; i++) {
                storyArcId = input.availableStoryArcs[i];
                storyArc = story.getStoryArcById(storyArcId);
                if (!storyArc) {
                    throw new Error(`Unkown storyarc id '${storyArcId}'`);
                }
                if (isNaN(input.availableStoryArcsTimes[storyArcId])) {
                    throw new Error(`Missing unlock time for '${storyArcId}'`);
                }
                this._availableStoryArcs.add(storyArc);
                this._availableStoryArcsTimes[storyArc.id] = input.availableStoryArcsTimes[storyArcId];
            }
        } else {
            throw new Error("availableStoryArcs data is invalid");
        }

        //Completed StoryArcs
        if (Array.isArray(input.completedStoryArcs) && input.completedStoryArcsTimes) {
            for (i = 0; i < input.completedStoryArcs.length; i++) {
                storyArcId = input.completedStoryArcs[i];
                storyArc = story.getStoryArcById(storyArcId);
                if (!storyArc) {
                    throw new Error(`Unkown storyarc id '${storyArcId}'`);
                }
                if (isNaN(input.completedStoryArcsTimes[storyArcId])) {
                    throw new Error(`Missing unlock time for '${storyArcId}'`);
                }
                this._completedStoryArcs.add(storyArc);
                this._completedStoryArcsTimes[storyArc.id] = input.completedStoryArcsTimes[storyArcId];
            }
        } else {
            throw new Error("completedStoryArcs data is invalid");
        }

        //Unlocked StoryNodes
        if (Array.isArray(input.unlockedStoryNodes) && input.unlockedStoryNodesTimes) {
            for (i = 0; i < input.unlockedStoryNodes.length; i++) {
                storyNodeId = input.unlockedStoryNodes[i];
                storyNode = story.getStoryNodeById(storyNodeId);
                if (!storyNode) {
                    throw new Error(`Unkown storyNode id '${storyNodeId}'`);
                }
                if (isNaN(input.unlockedStoryNodesTimes[storyNodeId])) {
                    throw new Error(`Missing unlock time for storyNode '${storyNodeId}'`);
                }
                this._unlockedStoryNodes.add(storyNode);
                this._unlockedStoryNodesTimes[storyNode.id] = input.unlockedStoryNodesTimes[storyNodeId];
            }
        } else {
            throw new Error("unlockedStoryNodes data is invalid");
        }

        //Available StoryNodes
        if (Array.isArray(input.availableStoryNodes) && input.availableStoryNodesTimes) {
            for (i = 0; i < input.availableStoryNodes.length; i++) {
                storyNodeId = input.availableStoryNodes[i];
                storyNode = story.getStoryNodeById(storyNodeId);
                if (!storyNode) {
                    throw new Error(`Unkown storyNode id '${storyNodeId}'`);
                }
                if (isNaN(input.availableStoryNodesTimes[storyNodeId])) {
                    throw new Error(`Missing available time for storyNode '${storyNodeId}'`);
                }
                this._availableStoryNodes.add(storyNode);
                this._availableStoryNodesTimes[storyNode.id] = input.availableStoryNodesTimes[storyNodeId];
            }
        } else {
            throw new Error("availableStoryNodes data is invalid");
        }

        //Completed StoryNodes
        if (Array.isArray(input.completedStoryNodes) && input.completedStoryNodesTimes) {
            for (i = 0; i < input.completedStoryNodes.length; i++) {
                storyNodeId = input.completedStoryNodes[i];
                storyNode = story.getStoryNodeById(storyNodeId);
                if (!storyNode) {
                    throw new Error(`Unkown storyNode id '${storyNodeId}'`);
                }
                if (isNaN(input.completedStoryNodesTimes[storyNodeId])) {
                    throw new Error(`Missing completed time for storyNode '${storyNodeId}'`);
                }
                this._completedStoryNodes.add(storyNode);
                this._completedStoryNodesTimes[storyNode.id] = input.completedStoryNodesTimes[storyNodeId];
            }
        } else {
            throw new Error("unlockedStoryNodes data is invalid");
        }
    }
}
